import {
  ModelUpdateCard,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedPortfolioUpdatesStepTemplate/ModelUpdateCard';
import { dataAttrs, testAttr } from 'Helpers/Testing';
import React from 'react';
import fr from 'facet-rest';
import { FDStack } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { withGuidedHouseholdReviewLayoutWithStepper } from 'Components/UI/guidedHouseholdReview/layoutWrapperWithStepper';
import {
  SecondaryActionButtonRel,
} from 'Packages/FacetCore/Experimental/RelationshipComponents/SecondaryActionButtonRel';

export const GuidedHouseholdReviewLayout = withGuidedHouseholdReviewLayoutWithStepper(() => {
  const { resource } = useMetaLayoutContext();
  return (
    <>
      <FDStack direction={'column'} paddingY={2} width={'100%'}>
        {resource.attr('modelUpdates').resources().list().map((modelUpdateResource, i) => (
          <ModelUpdateCard
            key={modelUpdateResource.id()}
            modelUpdateResource={modelUpdateResource}
            dataAttrs={{ ...dataAttrs('model-update-card', resource, { [testAttr.dataIndex]: i }) }}
          />
        ))}
      </FDStack>
      <FDStack justifyContent="center">
        <SecondaryActionButtonRel relationship={resource.relationship(fr.relationships.previousLink.name)} label={resource.attr('primaryActionLabel')} />
      </FDStack>
    </>
  );
}, { customButtons: true });
